/* eslint-disable prefer-const */
import { AdCommonEvents } from '../../constants'

export const Pixel2EventsDict = {
  [AdCommonEvents.Visit]: 'visit',
  [AdCommonEvents.RegNotFinished]: 'regnotfin',
  [AdCommonEvents.RegFinished]: 'regfin',
  [AdCommonEvents.LandingPageView]: 'landingpageview',
} as const satisfies Record<AdCommonEvents, string>

export type TPixel2Event = (typeof Pixel2EventsDict)[AdCommonEvents]

export type TPixel2Call = { event: TPixel2Event; userId?: number }

export class Pixel2 {
  static w: Window & { AU?: any } = typeof window !== 'undefined' ? window : ({} as any)
  static d = typeof window !== 'undefined' ? window.document : undefined
  static scriptId = 'ads-pixel-v2'
  static notCompletedEvent: TPixel2Event[] = []

  static eventPixelsDict: Record<TPixel2Event, number[]>

  static changeUserId = (userId?: number) => {
    const acl: Record<TPixel2Event, string> = {
      regfin: `1&extID=${userId}`,
      visit: `5&extID=${userId}`,
      regnotfin: `14&extID=${userId}`,
      landingpageview: `24&extID=${userId}`,
    }

    this.w.AU = this.w.AU || {}
    this.w.AU.acl = acl
    this.w.AU.setExtId?.(userId)
  }

  static init = ({
    aid,
    userId,
    eventDict,
  }: {
    aid: number
    userId?: number
    eventDict: Record<TPixel2Event, number[]>
  }) => {
    this.eventPixelsDict = eventDict
    this.w.AU = this.w.AU || {}
    this.changeUserId(userId)
    this.w.AU.aid = aid
    if (!this.d?.getElementById(this.scriptId)) {
      const a = this.d?.createElement('script')
      if (!a) return
      a.id = this.scriptId
      a.src = 'https://cdn.dspretargettraff.com/libs/a.js'
      a.onload = () => {
        if (this.notCompletedEvent.length) {
          this.notCompletedEvent.forEach((event) => {
            this.callEvent(event)
          })

          this.notCompletedEvent = []
        }
      }
      this.d?.body.appendChild(a)
    }
  }

  static callEvent = (event: TPixel2Event) => {
    if (!this.w.AU?.action) {
      this.notCompletedEvent.push(event)

      return
    }

    try {
      this.w.AU?.action(event)
    } catch (e: any) {
      console.error('[ADS:Pixel2] Error calling action:', e.message || e)
    }
  }

  static callPixelBy = (aPixelId: number, callback: (() => void) | null) => {
    let wn: any = this.w.navigator,
      ws = this.w.screen,
      z = 'WEBGL',
      hc,
      vc

    try {
      hc = wn.hardwareConcurrency
    } catch (p) {
      hc = 0
    }
    try {
      const ca = this.d?.createElement('canvas'),
        gl: any = ca?.getContext('experimental-' + z.toLowerCase())
      vc = escape(
        gl.getParameter(gl.getExtension(z + '_debug_renderer_info')['UNMASKED_RENDERER_' + z]),
      )
      ca?.remove() // clean up
    } catch (p: any) {
      console.warn('[ADS:Pixel2] Failed to create a canvas:', p.message || p)
    }
    const p: any = {
      sr: ws.width + 'x' + ws.height,
      tz: -new Date().getTimezoneOffset(),
      pl: wn.plugins && wn.plugins.length,
      mi: wn.mimeTypes && wn.mimeTypes.length,
      me: wn.deviceMemory,
      hc: hc,
      vc: vc,
    }
    let v
    let q = `https://rtb.dspretargettraff.com/au?a=${aPixelId}&`
    for (const k in p)
      if ((v = p[k]) && v !== 'undefined') {
        q += '&' + k + '=' + v
      }
    const img = new Image()

    img.onload = callback
    img.onerror = callback
    img.src = q
  }

  static cleanup = () => {
    const existingScript = this.d?.getElementById(this.scriptId)
    if (existingScript) existingScript.remove()
    delete this.w.AU
  }
}
